<template lang="pug">
.login-form.md-theme-agentiq
  .login-form__card
    h1.login-form__title {{ $t('auth.brand_title') }}
    p.login-form__subtitle {{ $t('auth.forgot_password.subtitle') }}

    form(@submit.prevent="submit")
      .login-form__field
        input(
          type="email"
          :placeholder="$t('auth.forgot_password.email_placeholder')"
          v-model="email"
          autocomplete="username"
          required
        )

      p.login-form__error(v-if="errorMessage") {{ errorMessage }}
      p.login-form__success(v-if="successMessage") {{ successMessage }}

      button.login-form__submit(type="submit", :disabled="loading || !!successMessage")
        | {{ loading ? $t('auth.forgot_password.submitting') : $t('auth.forgot_password.submit') }}

    p.login-form__footer
      router-link(to="/login") {{ $t('auth.forgot_password.back_to_sign_in') }}
</template>

<script>
import * as log from 'loglevel';
import { initSuperTokens, EmailPassword } from '@/libs/superTokens';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      errorMessage: '',
      successMessage: '',
      loading: false,
    };
  },
  methods: {
    async submit() {
      this.errorMessage = '';
      this.successMessage = '';
      this.loading = true;

      try {
        initSuperTokens();
        const response = await EmailPassword.sendPasswordResetEmail({
          formFields: [
            { id: 'email', value: this.email },
          ],
        });

        if (response.status === 'OK' || response.status === 'PASSWORD_RESET_NOT_ALLOWED') {
          this.successMessage = this.$t('auth.forgot_password.success');
          return;
        }

        if (response.status === 'FIELD_ERROR') {
          this.errorMessage = response.formFields
            .map((field) => field.error)
            .filter(Boolean)
            .join(', ') || this.$t('auth.forgot_password.error_field_fallback');
          return;
        }

        this.successMessage = this.$t('auth.forgot_password.success');
      } catch (err) {
        log.debug('auth: SuperTokens forgot password failed', err);
        this.errorMessage = this.$t('auth.forgot_password.error_generic');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
}

.login-form__card {
  width: 100%;
  max-width: 360px;
  padding: 32px 24px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.login-form__title {
  margin: 0 0 8px;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}

.login-form__subtitle {
  margin: 0 0 24px;
  color: #666;
  text-align: center;
}

.login-form__field {
  margin-bottom: 16px;

  input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
      border-color: #4671b3;
      outline: none;
    }
  }
}

.login-form__error {
  margin: 0 0 16px;
  color: #c62828;
  font-size: 14px;
}

.login-form__success {
  margin: 0 0 16px;
  color: #2e7d32;
  font-size: 14px;
}

.login-form__submit {
  width: 100%;
  margin-top: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background: #4671b3;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.login-form__footer {
  margin: 16px 0 0;
  text-align: center;
  font-size: 14px;
}
</style>
